import { VideoOffOutlineIcon } from './VideoOffOutlineIcon';

/**
 * author: Google
 * id 4CD11F14-5EB9-4532-910A-D9329CB1CE48
 * name video-off-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-off-outline.svg
 * tags
 * - Video / Movie 
 */
export const VideocamOffOutlineIcon = VideoOffOutlineIcon;
export default VideocamOffOutlineIcon